import { TaskList } from '@/components/task/TaskList';
import { BoardView } from '@/components/views/BoardView';
import { GanttChart as GanttChartView } from '@/components/task/GanttChart';
import { TeamView } from '@/components/views/TeamView';
import { TeamCalendarView } from '@/components/views/TeamCalendarView';
import { InboxView } from '@/components/views/InboxView';
import { TimesheetView } from '@/components/views/TimesheetView';
import { SprintView } from '@/components/views/SprintView';
import { CalendarView } from '@/components/views/CalendarView';
import { ProjectsView } from '@/components/views/ProjectsView';
import { DeviationsView } from '@/components/views/DeviationsView';
import { ReportView } from '@/components/views/ReportView';


export function ListViewRoute() {
  return <TaskList />;
}

export function BoardViewRoute() {
  return <BoardView />;
}

export function GanttViewRoute() {
  return <GanttChartView />;
}

export function InboxViewRoute() {
  return <InboxView />;
}

export function TeamViewRoute() {
  return <TeamView />;
}

export function TimesheetViewRoute() {
  return <TimesheetView />;
}

export function ProjectsViewRoute() {
  return <ProjectsView />;
}

export function DeviationsViewRoute() {
  return <DeviationsView />;
}

export function SprintViewRoute() {
  return <SprintView />;
}

export function CalendarViewRoute() {
  return <CalendarView />;
}


export function TeamCalendarViewRoute() {
  return <TeamCalendarView />;
}

export function ReportViewRoute() {
  return <ReportView />;
}
